// extracted by mini-css-extract-plugin
export default {"root":"Root_root__Vzs4c"};